"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePresenterStandaloneContext = void 0;
var _react = require("react");
var _contexts = require("../../contexts");
var usePresenterStandaloneContext = exports.usePresenterStandaloneContext = function usePresenterStandaloneContext() {
  var appContext = (0, _react.useContext)(_contexts.AppContext);
  var isPresenterStandalone = appContext === null || appContext === void 0 ? void 0 : appContext.isPresenterStandalone;
  if (isPresenterStandalone) return true;
  return false;
};